module.exports = __webpack_public_path__ + "static/media/canal-new-demi.db1dde64.woff2";